import { useState } from "react";
import { Menu, X } from "lucide-react";
import { SigilMark } from "./Sigil";
import { useCurrency } from "../context/CurrencyContext";

const LINKS = [
  { label: "Services", target: "services" },
  { label: "Grimoires", target: "grimoires" },
  { label: "Tarot", target: "tarot" },
  { label: "Whispers", target: "testimonials" },
  { label: "Pricing", target: "pricing" },
  { label: "Enquiry", target: "enquiry" },
];

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { currency, setCurrency } = useCurrency();

  return (
    <header
      data-testid="navbar"
      className="fixed top-0 w-full z-50 backdrop-blur-xl bg-ink/80 border-b border-gold/20"
    >
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <button
          data-testid="nav-brand"
          onClick={() => window.__lenis?.scrollTo(0)}
          className="flex items-center gap-3 text-gold"
        >
          <SigilMark className="w-9 h-9" spin />
          <span className="font-display tracking-[0.22em] text-sm sm:text-base text-parchment">
            PRISCA ARCANA
          </span>
        </button>

        <div className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.target}
              data-testid={`nav-link-${l.target}`}
              onClick={() => scrollToSection(l.target)}
              className="text-xs uppercase tracking-[0.2em] text-parchment-muted hover:text-gold transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-4">
          <button
            data-testid="currency-toggle-btn"
            onClick={() => setCurrency(currency === "usd" ? "inr" : "usd")}
            className="text-xs font-mono tracking-widest border border-gold/30 rounded-full px-3 py-1.5 text-parchment-muted hover:text-gold hover:border-gold/70 transition-colors duration-300"
            aria-label="Toggle currency"
          >
            {currency === "usd" ? "$ USD" : "₹ INR"}
          </button>
          <button
            data-testid="nav-book-consultation-btn"
            onClick={() => scrollToSection("pricing")}
            className="text-xs uppercase tracking-[0.2em] border border-gold/60 text-gold rounded-full px-5 py-2.5 hover:bg-gold hover:text-ink transition-colors duration-300"
          >
            Book Consultation
          </button>
        </div>

        <button
          data-testid="nav-mobile-menu-btn"
          className="lg:hidden text-gold"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="nav-mobile-drawer"
          className="lg:hidden border-t border-gold/20 bg-ink/95 backdrop-blur-xl px-6 py-6 flex flex-col gap-5"
        >
          {LINKS.map((l) => (
            <button
              key={l.target}
              data-testid={`nav-mobile-link-${l.target}`}
              onClick={() => {
                setOpen(false);
                scrollToSection(l.target);
              }}
              className="text-left text-sm uppercase tracking-[0.2em] text-parchment-muted hover:text-gold"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-currency-toggle"
            onClick={() => setCurrency(currency === "usd" ? "inr" : "usd")}
            className="text-left text-xs font-mono tracking-widest text-gold"
          >
            Currency: {currency === "usd" ? "$ USD" : "₹ INR"}
          </button>
        </div>
      )}
    </header>
  );
};
